module.exports = __webpack_public_path__ + "static/FOI-gov.cf28b754.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/FOI-gov.png
// module id = 484
// module chunks = 53566712009029